class SectionHero extends HTMLElement {
  constructor() {
    super();
    this.data = scrapeSectionData(this);
    this.section = this.querySelector("[data-text]");
    this.sectionNav = this.querySelector("[data-hero-navigation]");
    this.initFunction();
  }

  initFunction() {
    this.sectionNav &&
      this.sectionNav.addEventListener("click", (e) => {
        const nextSection = this.parentNode.nextElementSibling;
        nextSection && nextSection.scrollIntoView({ behavior: "smooth" });
      });

    this.initVideo();
  }

  // The inline script in the section normally sets the src during parse. This covers
  // re-renders where it didn't run, and swaps sources when the breakpoint is crossed.
  initVideo() {
    const video = this.querySelector("[data-hero-video] > video");
    if (!video) return;

    const mediaQuery = window.matchMedia(video.parentNode.dataset.mediaQuery);
    const poster = video.parentNode.querySelector(".video_placeholder img");
    const load = () => {
      const src =
        mediaQuery.matches && video.dataset.mediaSrcMobile
          ? video.dataset.mediaSrcMobile
          : video.dataset.mediaSrc;
      if (video.getAttribute("src") !== src) video.src = src;
    };

    if (!poster || poster.complete) {
      load();
    } else {
      poster.addEventListener("load", load, { once: true });
      poster.addEventListener("error", load, { once: true });
    }

    mediaQuery.addEventListener("change", load);
  }
}

if (!customElements.get("section-hero")) {
  customElements.define("section-hero", SectionHero);
}
